<template>
    <div class="index-brand">
        <div class="brand-hd">
            <span>品牌选择</span>
            <img @click="onBrandClose(false)" src="../../../assets/image/close@2x.png" />
        </div>
        <div class="brand-list">
            <div class="list-hd">
                <span>LOGO</span>
                <span>店铺名称</span>
                <span>所属品牌</span>
            </div>
            <div class="list-ct">
                <div class="list-it" v-for="(item,index) in brandList" :key="index"  @click="setBrand(item)">
                    <span>
                        <img :src="item && item.shopLogoUrl+'?x-oss-process=style/style_myfav_goods_img'" />
                    </span>
                    <span>{{item.shopName}}</span>
                    <span>{{item.brandName}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/utils/axios";
export default {
    data() {
        return {
            brandList:[]
        }
    },
    methods: {
        onBrandClose(item) {
            this.$emit('close',item)
        },
        getBrand() {
            http({
                url: "base/branch/branch/getBeeBranch?filterDiscount=1",
                method: "get"
            }).then(rps => {
                if (rps.code == 200) {
                    this.brandList = rps.data;
                    // this.brandList = [{"brandName":"SASA","shopId":"27","shopLogoUrl":"https://img-pre.chinabeego.com/uploadfile/2021/4/14/16183945584847363446581370273.jpg","shopName":"SASA 龙华8号仓店"},{"brandName":"GAP","shopId":"38","shopLogoUrl":"https://img-pre.chinabeego.com/img-public/7150020191229.jpg","shopName":"GAP 龙华8号仓店"},{"brandName":"MK","shopId":"39","shopLogoUrl":"https://img-pre.chinabeego.com/uploadfile/2021/4/14/16183945598077363447904553438.jpg","shopName":"MICHAEL KORS 龙华8号仓店"},{"brandName":"百丽国际","shopId":"40","shopLogoUrl":"https://img-pre.chinabeego.com/uploadfile/2021/6/30/162502070752613989675618935360.jpg","shopName":"百丽国际 龙华8号仓店"},{"brandName":"ECCO","shopId":"45","shopLogoUrl":"https://img-pre.chinabeego.com/uploadfile/2021/4/14/16183945606767363448773486589.jpg","shopName":"ECCO 龙华8号仓店"}]
                }
            });

        },
        setBrand(item){
            this.onBrandClose(item)
        }
    },
    created(){
        this.getBrand();
    }
}
</script>

<style lang="less" scoped>
.index-brand {
    height: 649px;
    padding-top: 40px;
    box-sizing: border-box;
    overflow: hidden;
    .brand-hd {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 40px;
        span {
            font-size: 32px;
            line-height: 45px;
            color: #000;
        }
        img {
            width: 38px;
            height: 38px;
        }
    }
    .brand-list {
        padding: 0 30px;
        font-size: 24px;
        margin-top: 30px;
        .list-ct {
            overflow-y: scroll;
            height: 450px;
            &::-webkit-scrollbar {display:none}
        }
        .list-hd {
            height: 81px;
            background-color: #F2F2F2;
        }
        .list-it {
            height: 100px;
            border-bottom: 1PX solid #F2F2F2;
        }
        .list-hd, .list-it {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            
            span {
                display: block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            span:first-child {
                width: 90px;
            }
            span:nth-child(2) {
                width: 250px;
            }
            span:last-child {
                width: 120px;
            }

        }
    }
}
</style>